/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_Cancel_ConfirmInputs */



/**
* | output |
* | --- |
* | "Cancel the league final? Its seating and result will be removed." |
*
* @param {League_Final_Cancel_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_cancel_confirm = /** @type {((inputs?: League_Final_Cancel_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_Cancel_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler la finale de ligue ? Son placement et son résultat seront supprimés.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cancelar la final de liga? Se borrarán sus asientos y su resultado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelar a final da liga? Os assentos e o resultado serão removidos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annullare la finale del campionato? Disposizione e risultato verranno rimossi.")
	return /** @type {LocalizedString} */ ("Cancel the league final? Its seating and result will be removed.")
});